<template>
  <div>
    <div
      class="
        buscador
        row
        input-group input-group-lg
        col-lg-12
        mx-auto
        px-0
        my-4
      "
      role="group"
      aria-label="first group"
    >
      <div class="col row buscador btn-group bg-gris-claro p-3 ml-0">
        <div class="col-12 row ml-0 mb-3 px-0">
          <InputPuntaje
            etiqueta="NEM"
            :obligatorio="true"
            :minVal="this.RANGO.MIN.NEM"
            :maxVal="
              simulacion.ranking >= this.RANGO.MIN.RANKING &&
              simulacion.ranking <= this.RANGO.MAX.RANKING
                ? simulacion.ranking
                : this.RANGO.MAX.NEM
            "
            v-model="simulacion.nem"
            divClass="col-6 col-lg mb-3 mb-lg-0 px-0 pr-3"
          />
          <InputPuntaje
            etiqueta="Ranking"
            :obligatorio="true"
            :minVal="this.RANGO.MIN.RANKING"
            :maxVal="this.RANGO.MAX.RANKING"
            v-model="simulacion.ranking"
            divClass="col-6 col-lg mb-3 mb-lg-0 px-0 pr-lg-3"
          />
          <InputPuntaje
            etiqueta="C. Lectora"
            :obligatorio="true"
            :minVal="this.RANGO.MIN.LENGUAJE"
            :maxVal="this.RANGO.MAX.LENGUAJE"
            v-model="simulacion.lenguaje"
            divClass="col-6 col-lg mb-3 mb-lg-0 px-0 pr-3"
          />
          <InputPuntaje
            etiqueta="C. Matemática 1"
            :obligatorio="true"
            :minVal="this.RANGO.MIN.MATEMATICA_1"
            :maxVal="this.RANGO.MAX.MATEMATICA_1"
            v-model="simulacion.matematica1"
            divClass="col-6 col-lg mb-3 mb-lg-0 px-0 pr-lg-3"
          />
          <InputPuntaje
            etiqueta="C. Matemática 2*"
            :obligatorio="false"
            :minVal="this.RANGO.MIN.MATEMATICA_2"
            :maxVal="this.RANGO.MAX.MATEMATICA_2"
            v-model="simulacion.matematica2"
            divClass="col-6 col-lg mb-3 mb-lg-0 px-0 pr-3"
          />
          <InputPuntaje
            etiqueta="Hist. y Cs. Sociales"
            :obligatorio="false"
            :minVal="this.RANGO.MIN.HISTORIA"
            :maxVal="this.RANGO.MAX.HISTORIA"
            v-model="simulacion.historia"
            divClass="col-6 col-lg mb-3 mb-lg-0 px-0 pr-lg-3"
          />
          <InputPuntaje
            etiqueta="Ciencias"
            :obligatorio="false"
            :minVal="this.RANGO.MIN.CIENCIAS"
            :maxVal="this.RANGO.MAX.CIENCIAS"
            v-model="simulacion.ciencias"
            divClass="col-6 col-lg px-0 pr-3 pr-lg-0"
          />
        </div>
        <div
          class="col col-md-12 d-block pl-1 pb-2 mr-auto"
          v-if="parseInt(simulacion.nem) > parseInt(simulacion.ranking)"
        >
          <p class="mb-0 text-rojo">
            <small>Puntaje NEM no debe ser mayor al Ranking</small>
          </p>
        </div>

        <div class="col-12 row px-0 ml-0 mb-0">
          <div
            class="
              buscador
              btn-group
              col-12 col-lg-4
              mb-3
              mt-3
              my-lg-0
              px-0
              pr-lg-3
            "
          >
            <div class="w-100 px-0 mb-lg-3">
              <b-form-select
                v-model="simulacion.region"
                class="custom-select form-control-lg multiple region"
                @change="cambiarRegion"
              >
                <option disabled value="null">Región</option>
                <option
                  v-for="r in regiones"
                  :key="r.idRegion"
                  :value="r.valorBusqueda"
                >
                  {{ limpiarNombreRegion(r.nombreRegion) }}
                </option>
                <option value="TODAS">Todas</option>
              </b-form-select>
            </div>
          </div>
          <div class="buscador btn-group col-12 col-lg mb-3 mb-lg-0 px-0">
            <div class="w-100 px-0 mb-lg-3">
              <b-form-select
                v-model="simulacion.nombreInstitucion"
                class="custom-select form-control-lg multiple instt"
                @change="cambiarInstitucion"
              >
                <option disabled value="null">Institución</option>
                <option
                  v-for="uni in universidades"
                  :key="uni.index"
                  :value="uni"
                >
                  {{ uni }}
                </option>
                <option value="TODAS">Todas</option>
              </b-form-select>
            </div>
          </div>
        </div>

        <div class="col-12 row px-0 ml-0 mb-0">
          <div class="buscador btn-group col-12 col-lg-4 mb-0 px-0">
            <div class="w-100 px-0 mr-lg-3 mb-3">
              <b-form-select
                v-model="simulacion.areaCarrera"
                class="custom-select multiple carrera"
                @change="cambiarArea"
              >
                <option disabled value="null">Area</option>
                <option v-for="area in areas" :key="area.index" :value="area">
                  {{ area }}
                </option>
                <option value="TODAS">Todas</option>
              </b-form-select>
            </div>
          </div>
          <div class="buscador btn-group col-12 col-lg mb-0 px-0">
            <div class="w-100 px-0 mb-3">
              <b-form-select
                v-model="simulacion.nombreCarreraGenerico"
                class="custom-select form-control-lg multiple gratuidad"
              >
                <option disabled value="null">Carrera</option>
                <option
                  v-for="carrera in carrerasGenericas"
                  :key="carrera.index"
                  :value="carrera"
                >
                  {{ carrera }}
                </option>
              </b-form-select>
            </div>
          </div>
        </div>

        <div class="col col-md-12 d-block pl-1 pt-2 mr-auto">
          <p class="mb-0">
            <small>
              Ingresa los puntajes (valores entre 100 y 1000) en los 4 campos
              obligatorios (NEM, Ranking, C. Lectora, C. Matemática 1) y al
              menos 1 resultado de pruebas electivas.
            </small>
          </p>
          <p class="mb-0">
            <small>
              <strong>*</strong> C. Matemática 2 (M2): Para realizar una
              simulación a las carreras que soliciten la rendición de la Prueba
              Competencia Matemática 2 (M2), debes ingresar un puntaje en la
              casilla M2. Si la institución no pondera esta prueba, el puntaje
              ingresado solo va a operar como un puntaje habilitante, es decir,
              que debe ser igual o superior a 100 (puntaje mínimo) para
              confirmar que rendiste la prueba. Esta no se considerará para el
              cálculo del puntaje simulado. En cambio, si la institución tiene
              como requisito la ponderación de la prueba M2, el puntaje
              ingresado se va a utilizar para el cálculo del puntaje ponderado.
            </small>
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-12 col-lg-3 input-lg align-self-center pr-lg-2 px-0 pb-3 pb-md-0"
      >
        <!--<button
          @click="recaptachaCallback"
          :disabled="disabledBoton"
          class="btn btn-blue w-100 rounded-0"
          type="button"
          id="inputGroupFileAddon"
        >
          SIMULAR1
        </button>-->
        <InvisibleRecaptcha
          ref="botonCaptchaFormulario"
          id="enviar-form"
          data-test="button-simular"
          :sitekey="siteKey"
          :validate="validarCampo"
          :callback="recaptachaCallback"
          theme="light"
          class="btn btn-blue w-100 rounded-0"
          :disabled="disabledBoton"
          type="submit"
          >SIMULAR</InvisibleRecaptcha
        >
      </div>

      <div class="col-12 col-lg-9 pr-md-3 px-0 ">
        <b-alert show variant="warning">
          <strong>¡IMPORTANTE!</strong>
          <br />
          <strong
            >El puntaje simulado y su transformación a la escala antigua (150 a
            850 puntos) es referencial, ya que cada proceso de admisión es
            distinto.El puntaje simulado en escala antigua (150 a 850 puntos) 
            se construyó en base a las ponderaciones y a las tablas de 
            equivalencia de puntaje publicadas por DEMRE. Su comparación 
            con los puntajes de último seleccionado de los procesos anteriores
            puede ser distinto al comportamiento para el proceso actual.
            <br />
            Esta es una fuente de información que te entregamos esperando pueda
            ayudarte en tu proceso de postulación.
</strong
          >
        </b-alert>
      </div>
    </div>
  </div>
</template>

<script>
import MixinRegiones from "@/mixins/regiones.js";
import ApiBuscador from "@/services/ApiBuscador";
import Busqueda from "@/utils/Busqueda.js";
import InputPuntaje from "@/components/simuladorPonderaciones/InputPuntaje";
import { MensajesDeCarga } from "@/utils/BusesDeEventos.js";
import { mapGetters, mapActions } from "vuex";
import InvisibleRecaptcha from "@/components/recaptcha/InvisibleRecaptcha";
import { EventBus } from "@/assets/js/EventBus";

export default {
  name: "Formulario",
  components: {
    InputPuntaje,
    InvisibleRecaptcha
  },
  mixins: [MixinRegiones],
  data() {
    return {
      simulacion: {
        nem: "",
        ranking: "",
        lenguaje: "",
        matematica1: "",
        matematica2: "",
        historia: "",
        ciencias: "",
        region: null,
        nombreInstitucion: null,
        nombreCarreraGenerico: null, //Nuevo valor: CARRERA_SIMULADOR
        areaCarrera: null //Nuevo Filtro: Area Simulador
      },
      config: {
        headers: {},
        params: {}
      },
      listadoInstituciones: [],
      siteKey: RECAPTCHA_PUBLIC_KEY,
      RANGO: {
        MIN: {
          NEM: 100,
          RANKING: 100,
          LENGUAJE: 100,
          MATEMATICA_1: 100,
          MATEMATICA_2: 100,
          HISTORIA: 100,
          CIENCIAS: 100
        },
        MAX: {
          NEM: 1000,
          RANKING: 1000,
          LENGUAJE: 1000,
          MATEMATICA_1: 1000,
          MATEMATICA_2: 1000,
          HISTORIA: 1000,
          CIENCIAS: 1000
        }
      }
    };
  },
  mounted() {
    this.limpiarFormulario();
    this.cargarDataPrevia();
  },
  async created() {
    this.listadoInstituciones = await this.cargarInstituciones();
    EventBus.$on("verifyCaptcha", token => {
      this.recaptachaCallback(token);
    });
  },
  computed: {
    ...mapGetters(["getDataSimulacion", "getBotonCaptcha"]),
    universidades() {
      if (this.listadoInstituciones.length >= 1) {
        let listado = this.listadoInstituciones;
        listado = this.filtrarRegion(listado);
        listado = listado.map(u => u.nombreInstitucion);
        listado = [...new Set(listado)];
        listado = this.limpiarNull(listado);
        listado.sort((a, b) => a.localeCompare(b));
        return listado;
      } else {
        return [];
      }
    },
    areas() {
      if (this.listadoInstituciones.length >= 1) {
        let listado = this.listadoInstituciones;
        listado = this.filtrarRegion(listado);
        listado = this.filtrarInstitucion(listado);
        listado = listado.map(u => u.areaSimulador);
        console.log("area, antes de set ", listado);
        listado = [...new Set(listado)];
        console.log("area, despues de set ", listado);
        listado = this.limpiarNull(listado);
        console.log("area, despues de limpiar null ", listado);
        listado.sort((a, b) => a.localeCompare(b));
        return listado;
      } else {
        return [];
      }
    },
    carrerasGenericas() {
      if (this.listadoInstituciones.length >= 1) {
        let listado = this.listadoInstituciones;
        listado = this.filtrarRegion(listado);
        listado = this.filtrarInstitucion(listado);
        listado = this.filtrarArea(listado);
        listado = listado.map(u => u.carreraSimulador);
        listado = [...new Set(listado)];
        listado = this.limpiarNull(listado);
        listado.sort((a, b) => a.localeCompare(b));
        return listado;
      } else {
        return [];
      }
    },
    disabledBoton() {
      if (
        this.simulacion.nem !== "" &&
        this.simulacion.nem > 0 &&
        this.simulacion.ranking !== "" &&
        this.simulacion.ranking > 0 &&
        this.simulacion.lenguaje !== "" &&
        this.simulacion.lenguaje > 0 &&
        this.simulacion.matematica1 !== "" &&
        this.simulacion.matematica1 > 0 &&
        this.simulacion.nem <= this.simulacion.ranking &&
        ((this.simulacion.ciencias !== "" && this.simulacion.ciencias > 0) ||
          (this.simulacion.historia != "" && this.simulacion.historia > 0))
      ) {
        return false;
      } else {
        return true;
      }
    },
    optionsGratuidad() {
      return Busqueda.criteriosGratuidad();
    }
  },
  methods: {
    ...mapActions(["setSimulacion", "setBotonCaptcha"]),
    recaptachaCallback(recaptchaToken) {
      if (recaptchaToken && this.getBotonCaptcha === "FORM") {
        MensajesDeCarga.$emit("cargar");
        this.config.headers = {
          "g-recaptcha-response": recaptchaToken
        };
        this.config.params = {
          area:
            this.simulacion.areaCarrera === "TODAS"
              ? null
              : this.simulacion.areaCarrera,
          ciencias:
            this.simulacion.ciencias === "" ? null : this.simulacion.ciencias,
          historia:
            this.simulacion.historia === "" ? null : this.simulacion.historia,
          lenguaje: this.simulacion.lenguaje,
          matematica1: this.simulacion.matematica1,
          matematica2:
            this.simulacion.matematica2 === ""
              ? null
              : this.simulacion.matematica2,
          nem: this.simulacion.nem,
          nombreCarreraGenerico:
            this.simulacion.nombreCarreraGenerico === "TODAS"
              ? null
              : this.simulacion.nombreCarreraGenerico,
          region:
            this.simulacion.region === "TODAS" ? null : this.simulacion.region,
          nombreInstitucion:
            this.simulacion.nombreInstitucion === "TODAS"
              ? null
              : this.simulacion.nombreInstitucion,
          ranking: this.simulacion.ranking
        };
        this.setSimulacion(this.simulacion);
        this.$ga.event({
          eventCategory: "Sistema-Acceso",
          eventAction: "simulador-ponderaciones",
          eventLabel: "boton-simular"
        });
        //this.setBotonCaptcha("");
        this.$emit("simular", this.config);
      }
    },
    cargarDataPrevia() {
      this.setBotonCaptcha("FORM");
      let simulacion = this.getDataSimulacion;
      if (Object.entries(simulacion).length !== 0) {
        this.simulacion.nem = simulacion.nem;
        this.simulacion.ranking = simulacion.ranking;
        this.simulacion.lenguaje = simulacion.lenguaje;
        this.simulacion.matematica1 = simulacion.matematica1;
        this.simulacion.matematica2 = simulacion.matematica2;
        this.simulacion.historia = simulacion.historia;
        this.simulacion.ciencias = simulacion.ciencias;
        this.simulacion.region = simulacion.region;
        this.simulacion.nombreInstitucion = simulacion.nombreInstitucion;
        this.simulacion.areaCarrera = simulacion.areaCarrera;
        this.simulacion.nombreCarreraGenerico =
          simulacion.nombreCarreraGenerico;
        let btn = this.$refs.botonCaptchaFormulario;
        console.log("cargardataprevia");
        btn.click();
      }
    },
    validarCampo() {
      let validado = true;
      this.setBotonCaptcha("FORM");
      if (
        !this.validRango(
          this.simulacion.nem,
          this.RANGO.MIN.NEM,
          this.RANGO.MAX.NEM
        )
      ) {
        return false;
      }
      if (
        !this.validRango(
          this.simulacion.ranking,
          this.RANGO.MIN.RANKING,
          this.RANGO.MAX.RANKING
        )
      ) {
        return false;
      }
      if (
        !this.validRango(
          this.simulacion.lenguaje,
          this.RANGO.MIN.LENGUAJE,
          this.RANGO.MAX.LENGUAJE
        )
      ) {
        return false;
      }
      if (
        !this.validRango(
          this.simulacion.matematica1,
          this.RANGO.MIN.MATEMATICA_1,
          this.RANGO.MAX.MATEMATICA_1
        )
      ) {
        return false;
      }
      if (this.simulacion.nem > this.simulacion.ranking) {
        return false;
      }
      if (
        (this.simulacion.historia !== "" && this.simulacion.historia !== "0") ||
        (this.simulacion.ciencias !== "" && this.simulacion.ciencias !== "0")
      ) {
        if (
          this.simulacion.historia !== "" &&
          this.simulacion.historia !== "0" &&
          !this.validRango(
            this.simulacion.historia,
            this.RANGO.MIN.HISTORIA,
            this.RANGO.MAX.HISTORIA
          )
        ) {
          return false;
        }
        if (
          this.simulacion.ciencias !== "" &&
          this.simulacion.ciencias !== "0" &&
          !this.validRango(
            this.simulacion.ciencias,
            this.RANGO.MIN.CIENCIAS,
            this.RANGO.MAX.CIENCIAS
          )
        ) {
          return false;
        }
      } else {
        return false;
      }
      return validado;
    },
    cambiarRegion() {
      this.simulacion.nombreInstitucion = null;
      this.simulacion.nombreCarreraGenerico = null;
      this.simulacion.areaCarrera = null;
    },
    cambiarInstitucion() {
      this.simulacion.nombreCarreraGenerico = null;
      this.simulacion.areaCarrera = null;
    },
    cambiarArea() {
      this.simulacion.nombreCarreraGenerico = null;
    },
    validRango(valor, min, max) {
      if (valor >= min && valor <= max) {
        return true;
      } else {
        return false;
      }
    },
    limpiarFormulario() {
      this.simulacion.nem = "";
      this.simulacion.ranking = "";
      this.simulacion.lenguaje = "";
      this.simulacion.matematica1 = "";
      this.simulacion.matematica2 = "";
      this.simulacion.historia = "";
      this.simulacion.ciencias = "";
    },
    async cargarInstituciones() {
      let parametros = {
        region:
          this.simulacion.region && this.simulacion.region !== "TODAS"
            ? this.simulacion.region
            : null,
        tipoPostulacion: "CENTRALIZADA"
      };
      let instituciones = await ApiBuscador.getListadoUniversidadesPorRegion(
        parametros
      );
      if (instituciones) {
        this.listadoInstituciones = instituciones;
      }
      return instituciones;
    },
    limpiarNull(listado) {
      let indenull = listado.indexOf(null);
      if (indenull !== -1) {
        listado.splice(indenull, 1);
      }
      return listado;
    },
    filtrarRegion(listado) {
      if (
        this.simulacion.region !== null &&
        this.simulacion.region !== "TODAS"
      ) {
        listado = listado.filter(c => c.region === this.simulacion.region);
      }
      return listado;
    },
    filtrarInstitucion(listado) {
      if (
        this.simulacion.nombreInstitucion !== null &&
        this.simulacion.nombreInstitucion !== "TODAS"
      ) {
        listado = listado.filter(
          c => c.nombreInstitucion === this.simulacion.nombreInstitucion
        );
      }
      return listado;
    },
    filtrarArea(listado) {
      if (
        this.simulacion.areaCarrera !== null &&
        this.simulacion.areaCarrera !== "TODAS"
      ) {
        listado = listado.filter(
          c => c.areaSimulador === this.simulacion.areaCarrera
        );
      }
      return listado;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/simuladorPonderaciones/Formulario.vue